import { HttpErrorResponse } from '@angular/common/http';

import type { Attachment } from '@recruitee/attachments-types';
import { createActions, ngrxEvent } from '@recruitee/ngrx';

import { EntityStoreKey } from '../types';

export const ViewboxAttachmentsActions = createActions(EntityStoreKey.ViewboxAttachments, {
  upload: ngrxEvent<{
    uuid: string;
    data: { [x: string]: any; file?: any };
    interviewTemplateToken: string;
    interviewRequestLinkToken: string;
  }>(),
  uploadSuccess: ngrxEvent<{ attachment: Attachment; uuid: string }>(),
  uploadFailed: ngrxEvent<{ error: HttpErrorResponse; uuid: string }>(),
  delete: ngrxEvent<{
    id: number;
    interviewTemplateToken: string;
    interviewRequestLinkToken: string;
  }>(),
  deleteSuccess: ngrxEvent<{ attachment: Attachment }>(),
  deleteFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
});
